module.exports = __webpack_public_path__ + "img/help.98c73001.svg";